import { useState, useRef, useEffect } from "react";
import { AreaChart, DonutChart } from "@tremor/react";
import { TrashIcon } from "@heroicons/react/24/outline";
import useAuth from "../../hooks/useAuth";
import {
  useGetAllMojDnevnikKorisnikQuery,
  useAddNewMojDnevnikMutation,
  useDeleteMojDnevnikMutation,
} from "./mojDnevnikApiSlice";
import EmojisChart from "./EmojiScatterChart";
import { useGetOneUserQuery } from "../users/usersApiSlice";

let MojDnevnik = () => {
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("male");
  const [weight, setWeight] = useState(""); // težina u kg
  const [height, setHeight] = useState(""); // visina u cm
  const [waist, setWaist] = useState(""); // obim struka u cm
  const [neck, setNeck] = useState(""); // obim vrata u cm
  const [hip, setHip] = useState(""); // obim kukova u cm (za žene)
  const [bodyFat, setBodyFat] = useState(null);
  const [bmi, setBmi] = useState(null);
  const [mojDnevnikData, setMojDnevnikData] = useState(null);
  const [datum, setDatum] = useState("");
  const [komentar, setKomentar] = useState("");
  const [emojiData, setEmojiData] = useState("");
  const [selectedEmoji, setSelectedEmoji] = useState(null);

  //
  const [DonutChartData, setDonutChartData] = useState("");
  const [primaryYAxis, setPrimaryYAxis] = useState("");
  const [chartData, setChartData] = useState("");

  const [bodyFatMass, setBodyFatMass] = useState(null);
  const [leanBodyMass, setLeanBodyMass] = useState(null);
  const [idealBodyFat, setIdealBodyFat] = useState(null);
  const [bodyFatToGain, setBodyFatToGain] = useState(null);

  const [bmiBodyFat, setBmiBodyFat] = useState(null);
  const [bodyFatCategory, setBodyFatCategory] = useState("");
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [showFormPopup, setShowFormPopup] = useState(false); // Stanje za popup forme
  const [fatLossAmount, setFatLossAmount] = useState(0);
  const { id } = useAuth();

  //Za brisanje popup
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalPitalica, setIsModalPitalica] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const {
    isSuccess: isSuccessUser,
    isError: isErrorUser,
    error: getUserError,
    data: getUserData,
  } = useGetOneUserQuery(id);

  //Get, update and delete record izvestaj dnevnika
  const {
    isSuccess: isSuccessGetDnevnikKorisnik,
    isError: isErrorGetDnevnikKorisnik,
    error: getDnevnikKorisnikError,
    data: getDnevnikKorisnikData,
  } = useGetAllMojDnevnikKorisnikQuery(id);
  const [
    addDnevnikKorisnik,
    {
      isSuccess: isSuccessAddDnevnikKorisnik,
      isError: isErrorAddDnevnikKorisnik,
      error: errorAddDnevnikKorisnik,
      data: dataAddDnevnikKorisnik,
    },
  ] = useAddNewMojDnevnikMutation();
  // const [updateCilj, { isSuccess: isSuccessUpdateCilj, isError: isErrorUpdateCilj, error: errorUpdateCilj, data: dataUpdateCilj }] = useUpdateCiljMutation();
  const [
    delDnevnikKorisnik,
    {
      isSuccess: isSuccessDelDnevnikKorisnik,
      isError: isErrorDelDnevnikKorisnik,
      error: errorDelDnevnikKorisnik,
      data: dataDelDnevnikKorisnik,
    },
  ] = useDeleteMojDnevnikMutation();

  //Get user
  useEffect(() => {
    if (isSuccessUser) {
      // console.log("Success response:", Object.values(getUserData.entities || {}));

      // setUser(getUserData)
      setAge(
        new Date().getFullYear() -
          new Date(getUserData.datumRodjenja).getFullYear() -
          (new Date() <
          new Date(getUserData.datumRodjenja).setFullYear(
            new Date(getUserData.datumRodjenja).getFullYear()
          )
            ? 1
            : 0)
      );
      setWeight(getUserData.tezina);
      setHeight(getUserData.visina);
      setWaist(getUserData.struk);
      setNeck(getUserData.vrat);
      setHip(getUserData.kuk);
      setDatum(getUserData.datumRodjenja);
      // console.log('User', getUserData)

      // data objekat je dobar response message
      // const successMessage = getUserData?.message
    }

    if (isErrorUser) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getUserError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessUser, isErrorUser, getUserError, getUserData]);

  //Get DnevnikKorisnik isSuccessGetDnevnikKorisnik && mojDnevnikData != null
  useEffect(() => {
    if (isSuccessGetDnevnikKorisnik) {
      // console.log("Success response:", Object.values(getCiljeviData.entities || {}));

      //DonutChartData1 extendedSampleData1
      setMojDnevnikData(Object.values(getDnevnikKorisnikData.entities || {}));

      const categoryCounts = Object.values(
        getDnevnikKorisnikData.entities || {}
      ).reduce((acc, item) => {
        acc[item.kategorija] = (acc[item.kategorija] || 0) + 1;
        return acc;
      }, {});

      const DonutChartData1 = Object.entries(categoryCounts).map(
        ([name, value]) => ({
          name,
          value,
        })
      );

      const mappedDonutChartData = DonutChartData1.map((item) => ({
        name: item.name,
        value: item.value,
      }));

      setDonutChartData(mappedDonutChartData);

      const extendedSampleData = Object.values(
        getDnevnikKorisnikData.entities || {}
      ).map((item) => ({
        datum: item.datum,
        telesnaMasa: parseFloat(item.telesnaMasa),
        procenatTelesneMase: parseFloat(item.procenatTelesneMase),
        cistaTelesnaMast: parseFloat(item.cistaTelesnaMast),
      }));

      const chartData = extendedSampleData.map((item) => ({
        date: item.datum,
        "Telesna Masti (kg)": item.telesnaMasa,
        "Procenat Telesne Masti (%)": item.procenatTelesneMase,
        "Čista Telesna Masa (kg)": item.cistaTelesnaMast,
      }));

      setChartData(chartData);

      const primaryYAxis = {
        label: "Kilograms",
        min: 0,
        max:
          Math.max(
            ...extendedSampleData.map((item) =>
              Math.max(item.telesnaMasa, item.cistaTelesnaMast)
            )
          ) + 10,
      };

      setPrimaryYAxis(primaryYAxis);

      //Data za grafik emotikona
      const emojiData = Object.values(getDnevnikKorisnikData.entities || {})
        // .slice()
        // .reverse()
        .map((item) => ({
          date: item.datum,
          emoji: item.emojiIcon,
          kg: parseInt(item.tezina),
        }));

      setEmojiData(emojiData);

      // data objekat je dobar response message
      // const successMessage = getCiljeviData?.message
    }

    if (isErrorGetDnevnikKorisnik) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getDnevnikKorisnikError?.data?.message;
      // alert(errorMessage);
    }
  }, [
    isSuccessGetDnevnikKorisnik,
    isErrorGetDnevnikKorisnik,
    getDnevnikKorisnikError,
    getDnevnikKorisnikData,
  ]);

  //Add DnevnikKorisnik
  useEffect(() => {
    if (isSuccessAddDnevnikKorisnik) {
      // if(isChecked){
      //   alert('Podaci sačuvani u profilu!!!!');
      //   setShowWarningPopup(false);
      //   setShowFormPopup(false);
      // }else{
      //   alert(dataAddDnevnikKorisnik.message.toString());
      // }
      // alert(dataAddDnevnikKorisnik.message.toString());
      setShowWarningPopup(false);
      setShowFormPopup(false);
      setIsModalPitalica(false);
      // if (isChecked) {
      //   window.location.reload();
      // }

      //change function
      // setPrimCiljNaziv('')
      // console.log(dataAddDnevnikKorisnik.message.toString())
    }

    if (isErrorAddDnevnikKorisnik) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddDnevnikKorisnik?.data?.message);
    }
  }, [
    isSuccessAddDnevnikKorisnik,
    isErrorAddDnevnikKorisnik,
    errorAddDnevnikKorisnik,
    dataAddDnevnikKorisnik,
  ]);

  //Update DnevnikKorisnik
  // useEffect(() => {
  //   if (isSuccessUpdateDnevnikKorisnik) {
  //     alert(dataUpdateDnevnikKorisnik.message.toString());
  //     // setPrimDnevnikKorisnikNaziv('')
  //     // console.log(dataAddDnevnikKorisnik.message.toString())
  //   }

  //   if (isErrorUpdateDnevnikKorisnik) {
  //     // console.log("Error object:", error);

  //     // error objekat je kada nam posalje error poruke
  //     alert(errorUpdateDnevnikKorisnik?.data?.message);
  //   }
  // }, [isSuccessUpdateDnevnikKorisnik, isErrorUpdateDnevnikKorisnik, errorUpdateDnevnikKorisnik, dataUpdateDnevnikKorisnik]);

  //Del DnevnikKorisnik
  useEffect(() => {
    if (isSuccessDelDnevnikKorisnik) {
      // alert(dataDelDnevnikKorisnik);
      closeModal();
      // console.log('delleted', dataDelDnevnikKorisnik)
    }

    if (isErrorDelDnevnikKorisnik) {
      alert(errorDelDnevnikKorisnik?.data?.message);
    }
  }, [
    isSuccessDelDnevnikKorisnik,
    isErrorDelDnevnikKorisnik,
    errorDelDnevnikKorisnik,
    dataDelDnevnikKorisnik,
  ]);

  //closeModal(); ZATVARA MODAL KAD IZBRISEMO
  //Brise prim cilj

  const [idDnevika, setIdDnevnika] = useState("");
  {
    /* openModal(true)  setIdDnevnikaZaBris*/
  }

  const setIdDnevnikaZaBris = (id) => {
    setIdDnevnika(id);
    openModal(true);
  };

  const handleDelDnevnikKorisnik = async () => {
    try {
      await delDnevnikKorisnik({ id: idDnevika });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  const handleClick = (emoji) => {
    setSelectedEmoji(emoji);
  };

  //Dodaje dnevnik ali u posebnu kolekciju a ne u profil
  // const handleAddDnevnikKorisnik = async (e) => {
  //   e.preventDefault();

  //   if (!primCiljNaziv) {
  //     alert("Molimo Vas unesite naziv cilja.");
  //     return;
  //   }

  //   try {
  //     await addCilj({ tip: "primaranCilj", naziv: primCiljNaziv });
  //   } catch (err) {
  //     console.error("Error occurred:", err);
  //   }
  // };

  const popupRef = useRef(null); // Ref za popup

  const calculateBodyFat = () => {
    let bodyFatPercentage;

    const waistNum = parseFloat(waist);
    const hipNum = parseFloat(hip);
    const neckNum = parseFloat(neck);
    const heightNum = parseFloat(height);
    const weightNum = parseFloat(weight);

    if (gender === "male") {
      bodyFatPercentage =
        495 /
          (1.0324 -
            0.19077 * Math.log10(waistNum - neckNum) +
            0.15456 * Math.log10(heightNum)) -
        450;
    } else {
      const waistHipNeck = waistNum + hipNum - neckNum;

      if (waistHipNeck > 0 && heightNum > 0) {
        bodyFatPercentage =
          495 /
            (1.29579 -
              0.35004 * Math.log10(waistHipNeck) +
              0.221 * Math.log10(heightNum)) -
          450;
      } else {
        alert("Pogrešan unos: struk + kuk - vrat moraju da budu veci od 0.");
        return;
      }
    }

    // console.log("Calculated Body Fat Percentage: ", bodyFatPercentage);

    if (bodyFatPercentage > 0) {
      setBodyFat(bodyFatPercentage.toFixed(2));

      const fatMass = (bodyFatPercentage / 100) * weightNum;
      const leanMass = weightNum - fatMass;

      setBodyFatMass(fatMass.toFixed(2));
      setLeanBodyMass(leanMass.toFixed(2));

      const idealBodyFatForAge = getIdealBodyFat(gender, age);
      setIdealBodyFat(idealBodyFatForAge.toFixed(2));

      const idealFatMass = (idealBodyFatForAge / 100) * weightNum;

      let fatAdjustment;
      if (bodyFatPercentage > idealBodyFatForAge) {
        fatAdjustment = fatMass - idealFatMass;
        setBodyFatToGain(0);
        setFatLossAmount(fatAdjustment > 0 ? fatAdjustment.toFixed(2) : 0);
      } else {
        fatAdjustment = idealFatMass - fatMass;
        setBodyFatToGain(fatAdjustment > 0 ? fatAdjustment.toFixed(2) : 0);
        setFatLossAmount(0);
      }

      // console.log("Fat Adjustment (kg): ", fatAdjustment);

      const bmi = (weightNum / (heightNum / 100) ** 2).toFixed(2);
      setBmi(bmi);
      const bmiBodyFatPercentage = (1.2 * bmi + 0.23 * age - 5.4).toFixed(2);
      setBmiBodyFat(bmiBodyFatPercentage);

      const category = getBodyFatCategory(bodyFatPercentage, gender);
      setBodyFatCategory(category);
    } else {
      alert("Proverite vaš unos.");
    }
  };

  const getIdealBodyFat = (gender, age) => {
    if (gender === "male") {
      if (age === 23) return 9.7;
      if (age < 25) return 10.5;
      if (age < 30) return 12.7;
      if (age < 35) return 13.7;
      if (age < 40) return 15.3;
      if (age < 45) return 16.4;
      if (age < 50) return 18.9;
      if (age < 55) return 20.9;
    } else {
      if (age === 23) return 18.4;
      if (age < 25) return 18.4;
      if (age < 30) return 19.3;
      if (age < 35) return 21.5;
      if (age < 40) return 22.2;
      if (age < 45) return 22.9;
      if (age < 50) return 25.2;
      if (age < 55) return 26.3;
    }
    return 0;
  };

  const getBodyFatCategory = (bodyFatPercentage, gender) => {
    if (gender === "male") {
      if (bodyFatPercentage < 6) return "Osnovna mast";
      if (bodyFatPercentage < 14) return "Sportista";
      if (bodyFatPercentage < 24) return "Fit";
      if (bodyFatPercentage < 31) return "Prosečna";
      return "Gojaznost";
    } else {
      if (bodyFatPercentage < 10) return "Osnovna mast";
      if (bodyFatPercentage < 14) return "Sportista";
      if (bodyFatPercentage < 21) return "Fit";
      if (bodyFatPercentage < 32) return "Prosečna";
      return "Gojaznost";
    }
  };

  //Da moze da bira smo danas i naredne dane
  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  const closeModalPosta = () => {
    setShowWarningPopup(false);
  };

  //Cuva samo u kolekciju MojDnevnik - work here
  // const handleSacuvajClick = async () => {
  //   setIsModalPitalica(false);
  //   if (isChecked) {
  //     if (
  //       age != "" &&
  //       gender != "" &&
  //       weight != "" &&
  //       height != "" &&
  //       waist != "" &&
  //       neck != "" &&
  //       datum != ""
  //     ) {
  //       setPopupMessage(
  //         "Da li ste sigurni da želite postojeće podatke da integrišete u profil?"
  //       );
  //       setShowWarningPopup(true);
  //     } else {
  //       alert("Morate popuniti sva polja pre čuvanja podataka");
  //     }
  //   } else {
  //     if (
  //       age != "" &&
  //       gender != "" &&
  //       weight != "" &&
  //       height != "" &&
  //       waist != "" &&
  //       neck != "" &&
  //       datum != ""
  //     ) {
  //       // alert('Podaci sačuvani u profilu!');  //Pomeri u useEffect
  //       setShowFormPopup(false);
  //       //Trigger update hook u posebnu kolekciju HERE
  //       try {
  //         //Poslaji podatke da se dodaju u kolekciju i dole u funkciju kad se cekira checkbox u profil
  //         //Rebootuj procese preko pm2 menadzera
  //         await addDnevnikKorisnik({
  //           id,
  //           datum,
  //           age,
  //           weight,
  //           height,
  //           waist,
  //           neck,
  //           hip,
  //           bmi,
  //           bodyFat,
  //           fatLossAmount,
  //           bodyFatCategory,
  //           bmiBodyFat,
  //           bodyFatToGain,
  //           idealBodyFat,
  //           leanBodyMass,
  //           bodyFatMass,
  //           isChecked,
  //           komentar,
  //           emojiIcon: selectedEmoji,
  //         });
  //       } catch (err) {
  //         console.error("Error occurred:", err);
  //       }
  //     } else {
  //       alert("Morate popuniti sva polja pre čuvanja podataka");
  //     }
  //   }
  // };

  const handleSacuvajClick = async () => {
    if (selectedEmoji != null || komentar != "") {
      // setIsModalPitalica(false);
      if (isChecked) {
        handleIntegrisi();
        // setPopupMessage(
        //   "Da li ste sigurni da želite postojeće podatke da integrišete u profil?"
        // );
        // setShowWarningPopup(true);
      } else {
        setShowFormPopup(false);
        setIsModalPitalica(false);
        try {
          await addDnevnikKorisnik({
            id,
            datum: new Date().toISOString().split("T")[0],
            age,
            weight,
            height,
            waist,
            neck,
            hip,
            bmi,
            bodyFat,
            fatLossAmount,
            bodyFatCategory,
            bmiBodyFat,
            bodyFatToGain,
            idealBodyFat,
            leanBodyMass,
            bodyFatMass,
            isChecked,
            komentar,
            emojiIcon: selectedEmoji,
          });
        } catch (err) {
          console.error("Error occurred:", err);
        }
      }
    } else {
      alert("Unesite smajlija i kometar!");
    }
  };

  //Integrise u profil i cuva u kolekciju mojDnevnik
  const handleIntegrisi = async () => {
    try {
      await addDnevnikKorisnik({
        id,
        datum: new Date().toISOString().split("T")[0],
        age,
        weight,
        height,
        waist,
        neck,
        hip,
        bmi,
        bodyFat,
        fatLossAmount,
        bodyFatCategory,
        bmiBodyFat,
        bodyFatToGain,
        idealBodyFat,
        leanBodyMass,
        bodyFatMass,
        komentar,
        isChecked,
        emojiIcon: selectedEmoji,
      });
    } catch (err) {
      console.error("Error occurred:", err);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowFormPopup(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [popupRef]);

  //Chart za prva 3
  // const extendedSampleData = [
  //   { datum: '2024-09-25', telesnaMasa: 72, procenatTelesneMase: 23, cistaTelesnaMast: 55.4 },
  //   { datum: '2024-09-26', telesnaMasa: 71, procenatTelesneMase: 22.5, cistaTelesnaMast: 54.8 },
  //   { datum: '2024-09-27', telesnaMasa: 70, procenatTelesneMase: 22, cistaTelesnaMast: 54.0 },
  //   { datum: '2024-09-28', telesnaMasa: 69, procenatTelesneMase: 21.5, cistaTelesnaMast: 53.2 },
  //   { datum: '2024-09-29', telesnaMasa: 68, procenatTelesneMase: 21, cistaTelesnaMast: 52.5 },
  // ];

  // Map data to the format required by Tremor
  // const chartData = extendedSampleData.map((item) => ({
  //   date: item.datum,
  //   "Telesna Masti (kg)": item.telesnaMasa, // Renaming for display
  //   "Procenat Telesne Masti (%)": item.procenatTelesneMase, // Renaming for display
  //   "Čista Telesna Mast (kg)": item.cistaTelesnaMast, // Renaming for display
  // }));

  // // Define the Y-axis for weight and body mass
  // const primaryYAxis = {
  //   label: 'Kilograms',
  //   min: 0,
  //   max: Math.max(...extendedSampleData.map(item => Math.max(item.telesnaMasa, item.cistaTelesnaMast))) + 10,
  // };

  // Define the secondary Y-axis for body fat percentage
  const secondaryYAxis = {
    label: "Body Fat Percentage (%)",
    min: 0,
    max: 40,
  };

  // const closeOpenModal = () => {

  // }

  //Za Kategorije - Obesity (20%), Essential Fat (5%), Fit (25%), Average (35%), Athlete (15%)

  // const emojiData = [  --Brisi
  //   { date: "2025-02-01", emoji: "😡", kg: 70 },
  //   { date: "2025-02-02", emoji: "😞", kg: 71 },
  //   { date: "2025-02-03", emoji: "😐", kg: 72 },
  //   { date: "2025-02-04", emoji: "😐", kg: 71 },
  //   { date: "2025-02-05", emoji: "😐", kg: 72 },
  //   { date: "2025-02-06", emoji: "😊", kg: 73 },
  //   { date: "2025-02-07", emoji: "😁", kg: 74 },
  //   { date: "2025-02-08", emoji: "😁", kg: 75 },
  //   { date: "2025-02-09", emoji: "😁", kg: 76 },
  //   { date: "2025-02-10", emoji: "😡", kg: 77 },
  //   { date: "2025-02-11", emoji: "😡", kg: 78 },
  //   { date: "2025-02-12", emoji: "😊", kg: 79 },
  // ];

  return (
    <>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-base">
          Ovo je Vaš dnevnik u kome vodite evidencije o telesnim mastima.
        </h1>

        <button
          onClick={() => setShowFormPopup(true)}
          className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
        >
          Kreiraj evidenciju
        </button>
      </div>

      <div className="">
        {/* Scrollable 70% Section with Y-axis scrolling only when content exceeds the container height */}

        {/* <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.struk}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.vrat}
                          </td> */}

        {/* <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Struk (cm)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Vrat (cm)
                      </th> */}

        {/* Starta NE RESPONSIVE TABELA */}
        {/* <div className="w-full">
          <div className="flow-root">
            <div className="inline-block min-w-full py-2 align-middle">
              <div className="overflow-x-auto">
                <table className="min-w-full border-collapse border border-gray-300">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Datum
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Godine
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Težina (kg)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Visina (cm)
                      </th>

                      {gender === "female" && (
                        <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                          Kuk (cm)
                        </th>
                      )}
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        BMI (kg/m&sup2;)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Procenat telesne masti (%)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Telesna masa (kg)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Čista telesna masa (kg)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Idealne telesne masti (%)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Potrebno povecanje | smanjenje telesne mase (kg)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Telesna masa BMI (%)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Kategorija telesne mase
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Raspoloženje
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Komentar
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"></th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    {isSuccessGetDnevnikKorisnik &&
                      mojDnevnikData != null &&
                      mojDnevnikData.map((item) => (
                        <tr key={item._id}>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                            {item.datum}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.god}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.tezina}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.visina}
                          </td>

                          {gender === "female" && (
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item.kuk}
                            </td>
                          )}
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.bmi}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.procenatTelesneMase}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.telesnaMasa}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.cistaTelesnaMast}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.idealneTelesneMasti}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900 text-center">
                            <span className="inline-block">
                              {item.povecanje}
                            </span>
                            <span className="mx-2">|</span>
                            <span className="inline-block">
                              {item.smanjenje}
                            </span>
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.telesnaMasaBmi}
                          </td>
                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item.kategorija}
                          </td>

                          <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                            {item?.emojiIcon}
                          </td>
                          <td
                            className="border-b border-r px-4 py-2 text-sm text-gray-900 cursor-pointer"
                            title={item?.komentar}
                          >
                            {item?.komentar?.length > 10
                              ? `${item?.komentar.slice(0, 10)}...`
                              : item?.komentar}
                          </td>

                          <td
                            className="border-b border-r px-2 py-2 text-sm text-gray-900"
                            onClick={() => setIdDnevnikaZaBris(item._id)}
                          >
                            <TrashIcon
                              className="h-5 w-5 shrink-0 cursor-pointer stroke-red-600"
                              aria-hidden="true"
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                {mojDnevnikData == null && (
                  <p className="text-lg font-bold text-center py-4">
                    Nemate ni jednu evidenciju u dnevniku
                  </p>
                )}
              </div>
            </div>
          </div>
        </div> */}

        {/* Ideja 1 */}
        {/* <div className="w-full">
          <div className="flow-root">
            <div className="inline-block min-w-full py-2 align-middle">
              <div className="overflow-hidden">
                <table className="min-w-full border-collapse border border-gray-300 hidden sm:table">
                  {" "}
         
                </table>

                <div className="sm:hidden">
                  {" "}
       
                  {isSuccessGetDnevnikKorisnik &&
                    mojDnevnikData != null &&
                    mojDnevnikData.map((item) => (
                      <div
                        key={item._id}
                        className="border border-gray-300 rounded-md p-4 mb-4"
                      >
                        <div className="flex justify-between mb-2">
                          <span className="font-semibold">Datum:</span>
                          <span>{item.datum}</span>
                        </div>
                        <div className="flex justify-between mb-2">
                          <span className="font-semibold">Godine:</span>
                          <span>{item.god}</span>
                        </div>
                        <div className="flex justify-between mb-2">
                          <span className="font-semibold">Težina (kg):</span>
                          <span>{item.tezina}</span>
                        </div>
                   
                        <div className="flex justify-between mb-2">
                          <span className="font-semibold">Komentar:</span>
                          <span title={item?.komentar}>
                            {item?.komentar?.length > 10
                              ? `${item?.komentar.slice(0, 10)}...`
                              : item?.komentar}
                          </span>
                        </div>
                        <div className="flex justify-end">
                          <button
                            onClick={() => setIdDnevnikaZaBris(item._id)}
                            className="text-red-600"
                          >
                            <TrashIcon className="h-5 w-5" />
                          </button>
                        </div>
                      </div>
                    ))}
                  {mojDnevnikData == null && (
                    <p className="text-lg font-bold text-center py-4">
                      Nemate ni jednu evidenciju u dnevniku
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* ideja 2 */}
        {/* <div className="w-full">
          <div className="flow-root">
            <div className="inline-block min-w-full py-2 align-middle">
              <div className="overflow-hidden">
                <table className="min-w-full border-collapse border border-gray-300 hidden sm:table"></table>

                <div className="sm:hidden">
                  {isSuccessGetDnevnikKorisnik &&
                    mojDnevnikData != null &&
                    mojDnevnikData.map((item) => (
                      <div
                        key={item._id}
                        className="border border-gray-300 rounded-md p-4 mb-4"
                      >
                        <div className="flex justify-between mb-2">
                          <span className="font-semibold">Datum:</span>
                          <span>{item.datum}</span>
                        </div>
                        <div className="flex justify-between mb-2">
                          <span className="font-semibold">Godine:</span>
                          <span>{item.god}</span>
                        </div>

                        <details className="mb-2">
                          <summary className="font-semibold cursor-pointer">
                            Merenja
                          </summary>
                          <div className="pl-4">
                            <div className="flex justify-between mb-1">
                              <span>Težina (kg):</span>
                              <span>{item.tezina}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>Visina (cm):</span>
                              <span>{item.visina}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>BMI (kg/m&sup2;):</span>
                              <span>{item.bmi}</span>
                            </div>
                          </div>
                        </details>

                        <div className="flex justify-between mb-2">
                          <span className="font-semibold">Komentar:</span>
                          <span title={item?.komentar}>
                            {item?.komentar?.length > 10
                              ? `${item?.komentar.slice(0, 10)}...`
                              : item?.komentar}
                          </span>
                        </div>
                        <div className="flex justify-end">
                          <button
                            onClick={() => setIdDnevnikaZaBris(item._id)}
                            className="text-red-600"
                          >
                            <TrashIcon className="h-5 w-5" />
                          </button>
                        </div>
                      </div>
                    ))}

                  {mojDnevnikData == null && (
                    <p className="text-lg font-bold text-center py-4">
                      Nemate ni jednu evidenciju u dnevniku
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Ideja 3 */}
        {/* <div className="w-full">
          <div className="flow-root">
            <div className="inline-block min-w-full py-2 align-middle">
              <div className="overflow-hidden">
                <table className="min-w-full border-collapse border border-gray-300 hidden sm:table">
             
                </table>

                <div className="sm:hidden">
                  {isSuccessGetDnevnikKorisnik &&
                    mojDnevnikData != null &&
                    mojDnevnikData.map((item) => (
                      <div
                        key={item._id}
                        className="border border-gray-300 rounded-md p-4 mb-4"
                      >
                        <details className="mb-2">
                          <summary className="font-semibold cursor-pointer">
                            Osnovni podaci
                          </summary>
                          <div className="pl-4">
                            <div className="flex justify-between mb-1">
                              <span>Datum:</span>
                              <span>{item.datum}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>Godine:</span>
                              <span>{item.god}</span>
                            </div>
                          </div>
                        </details>

                        <details className="mb-2">
                          <summary className="font-semibold cursor-pointer">
                            Merenja
                          </summary>
                          <div className="pl-4">
                            <div className="flex justify-between mb-1">
                              <span>Težina (kg):</span>
                              <span>{item.tezina}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>Visina (cm):</span>
                              <span>{item.visina}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>BMI (kg/m&sup2;):</span>
                              <span>{item.bmi}</span>
                            </div>
                            {gender === "female" && (
                              <div className="flex justify-between mb-1">
                                <span>Kuk (cm):</span>
                                <span>{item.kuk}</span>
                              </div>
                            )}
                          </div>
                        </details>

                        <details className="mb-2">
                          <summary className="font-semibold cursor-pointer">
                            Ostalo
                          </summary>
                          <div className="pl-4">
                            <div className="flex justify-between mb-1">
                              <span>Procenat telesne masti (%):</span>
                              <span>{item.procenatTelesneMase}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>Telesna masa (kg):</span>
                              <span>{item.telesnaMasa}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>Čista telesna masa (kg):</span>
                              <span>{item.cistaTelesnaMast}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>Idealne telesne masti (%):</span>
                              <span>{item.idealneTelesneMasti}</span>
                            </div>
                            <div className="flex justify-center mb-1">
                              <span>
                                Potrebno povećanje | smanjenje telesne mase
                                (kg):
                              </span>
                            </div>
                            <div className="flex justify-center mb-1">
                              <span>{item.povecanje}</span>
                              <span className="mx-2">|</span>
                              <span>{item.smanjenje}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>Telesna masa BMI (%):</span>
                              <span>{item.telesnaMasaBmi}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>Kategorija telesne mase:</span>
                              <span>{item.kategorija}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>Raspoloženje:</span>
                              <span>{item?.emojiIcon}</span>
                            </div>
                            <div className="flex justify-between mb-1">
                              <span>Komentar:</span>
                              <span title={item?.komentar}>
                                {item?.komentar?.length > 10
                                  ? `${item?.komentar.slice(0, 10)}...`
                                  : item?.komentar}
                              </span>
                            </div>
                          </div>
                        </details>

                        <div className="flex justify-end">
                          <button
                            onClick={() => setIdDnevnikaZaBris(item._id)}
                            className="text-red-600"
                          >
                            <TrashIcon className="h-5 w-5" />
                          </button>
                        </div>
                      </div>
                    ))}

                  {mojDnevnikData == null && (
                    <p className="text-lg font-bold text-center py-4">
                      Nemate ni jednu evidenciju u dnevniku
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Ideja 4 */}
        {/* <div className="w-full">
          <div className="flow-root">
            <div className="inline-block min-w-full py-2 align-middle">
              <div className="overflow-hidden sm:hidden">
                {" "}
         
                {isSuccessGetDnevnikKorisnik &&
                  mojDnevnikData != null &&
                  mojDnevnikData.map((item) => (
                    <div
                      key={item._id}
                      className="border border-gray-300 rounded-md p-4 mb-4"
                    >
                      <details className="mb-2">
                        <summary className="font-semibold cursor-pointer">
                          Osnovni podaci
                        </summary>
                        <div className="pl-4">
                          <div className="flex justify-between mb-1">
                            <span>Datum:</span>
                            <span>{item.datum}</span>
                          </div>
                          <div className="flex justify-between mb-1">
                            <span>Godine:</span>
                            <span>{item.god}</span>
                          </div>
                        </div>
                      </details>

                      <details className="mb-2">
                        <summary className="font-semibold cursor-pointer">
                          Merenja
                        </summary>
                        <div className="pl-4">
                          <div className="flex justify-between mb-1">
                            <span>Težina (kg):</span>
                            <span>{item.tezina}</span>
                          </div>
                          <div className="flex justify-between mb-1">
                            <span>Visina (cm):</span>
                            <span>{item.visina}</span>
                          </div>
                          <div className="flex justify-between mb-1">
                            <span>BMI (kg/m&sup2;):</span>
                            <span>{item.bmi}</span>
                          </div>
                          {gender === "female" && (
                            <div className="flex justify-between mb-1">
                              <span>Kuk (cm):</span>
                              <span>{item.kuk}</span>
                            </div>
                          )}
                        </div>
                      </details>

                      <details className="mb-2">
                        <summary className="font-semibold cursor-pointer">
                          Ostalo
                        </summary>
                        <div className="pl-4">
                          <div className="flex justify-between mb-1">
                            <span>Procenat telesne masti (%):</span>
                            <span>{item.procenatTelesneMase}</span>
                          </div>
                          <div className="flex justify-between mb-1">
                            <span>Telesna masa (kg):</span>
                            <span>{item.telesnaMasa}</span>
                          </div>
                          <div className="flex justify-between mb-1">
                            <span>Čista telesna masa (kg):</span>
                            <span>{item.cistaTelesnaMast}</span>
                          </div>
                          <div className="flex justify-between mb-1">
                            <span>Idealne telesne masti (%):</span>
                            <span>{item.idealneTelesneMasti}</span>
                          </div>
                          <div className="flex justify-center mb-1">
                            <span>
                              Potrebno povećanje | smanjenje telesne mase (kg):
                            </span>
                          </div>
                          <div className="flex justify-center mb-1">
                            <span>{item.povecanje}</span>
                            <span className="mx-2">|</span>
                            <span>{item.smanjenje}</span>
                          </div>
                          <div className="flex justify-between mb-1">
                            <span>Telesna masa BMI (%):</span>
                            <span>{item.telesnaMasaBmi}</span>
                          </div>
                          <div className="flex justify-between mb-1">
                            <span>Kategorija telesne mase:</span>
                            <span>{item.kategorija}</span>
                          </div>
                          <div className="flex justify-between mb-1">
                            <span>Raspoloženje:</span>
                            <span>{item?.emojiIcon}</span>
                          </div>
                          <div className="flex justify-between mb-1">
                            <span>Komentar:</span>
                            <span title={item?.komentar}>
                              {item?.komentar?.length > 10
                                ? `${item?.komentar.slice(0, 10)}...`
                                : item?.komentar}
                            </span>
                          </div>
                        </div>
                      </details>

                      <div className="flex justify-end">
                        <button
                          onClick={() => setIdDnevnikaZaBris(item._id)}
                          className="text-red-600"
                        >
                          <TrashIcon className="h-5 w-5" />
                        </button>
                      </div>
                    </div>
                  ))}
                {mojDnevnikData == null && (
                  <p className="text-lg font-bold text-center py-4">
                    Nemate ni jednu evidenciju u dnevniku
                  </p>
                )}
              </div>
            </div>
          </div>
        </div> */}

        {/* Ideja 5 */}
        <div className="w-full">
          <div className="flow-root">
            <div className="inline-block min-w-full py-2 align-middle">
              <div className="overflow-hidden">
                {/* Originalna tabela (za desktop) */}
                <table className="min-w-full border-collapse border border-gray-300 hidden sm:table">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Datum
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Godine
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Težina (kg)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Visina (cm)
                      </th>

                      {gender === "female" && (
                        <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                          Kuk (cm)
                        </th>
                      )}
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        BMI (kg/m&sup2;)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Procenat telesne masti (%)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Telesna masa (kg)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Čista telesna masa (kg)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Idealne telesne masti (%)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Potrebno povecanje | smanjenje telesne mase (kg)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Telesna masa BMI (%)
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Kategorija telesne mase
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Raspoloženje
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900">
                        Komentar
                      </th>
                      <th className="border-b border-r px-4 py-2 text-left text-sm font-semibold text-gray-900"></th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">
                    {isSuccessGetDnevnikKorisnik &&
                      mojDnevnikData != null &&
                      mojDnevnikData
                        .slice()
                        .reverse()
                        .map((item) => (
                          <tr key={item._id}>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900 whitespace-nowrap">
                              {item.datum}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item.god}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item.tezina}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item.visina}
                            </td>

                            {gender === "female" && (
                              <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                                {item.kuk}
                              </td>
                            )}
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item.bmi}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item.procenatTelesneMase}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item.telesnaMasa}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item.cistaTelesnaMast}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item.idealneTelesneMasti}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900 text-center">
                              <span className="inline-block">
                                {item.povecanje}
                              </span>
                              <span className="mx-2">|</span>
                              <span className="inline-block">
                                {item.smanjenje}
                              </span>
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item.telesnaMasaBmi}
                            </td>
                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item.kategorija}
                            </td>

                            <td className="border-b border-r px-4 py-2 text-sm text-gray-900">
                              {item?.emojiIcon}
                            </td>
                            <td
                              className="border-b border-r px-4 py-2 text-sm text-gray-900 cursor-pointer"
                              title={item?.komentar}
                            >
                              {item?.komentar?.length > 10
                                ? `${item?.komentar.slice(0, 10)}...`
                                : item?.komentar}
                            </td>

                            <td
                              className="border-b border-r px-2 py-2 text-sm text-gray-900"
                              onClick={() => setIdDnevnikaZaBris(item._id)}
                            >
                              <TrashIcon
                                className="h-5 w-5 shrink-0 cursor-pointer stroke-red-600"
                                aria-hidden="true"
                              />
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>

                {/* Accordion komponente (za mobilne) */}
                <div className="sm:hidden">
                  {isSuccessGetDnevnikKorisnik &&
                    mojDnevnikData != null &&
                    mojDnevnikData
                      .slice()
                      .reverse()
                      .map((item) => (
                        <div
                          key={item._id}
                          className="border border-gray-300 rounded-md p-4 mb-4"
                        >
                          <details className="mb-2">
                            <summary className="font-semibold cursor-pointer">
                              Osnovni podaci
                            </summary>
                            <div className="pl-4">
                              <div className="flex justify-between mb-1">
                                <span>Datum:</span>
                                <span>{item.datum}</span>
                              </div>
                              <div className="flex justify-between mb-1">
                                <span>Godine:</span>
                                <span>{item.god}</span>
                              </div>
                            </div>
                          </details>

                          <details className="mb-2">
                            <summary className="font-semibold cursor-pointer">
                              Merenja
                            </summary>
                            <div className="pl-4">
                              <div className="flex justify-between mb-1">
                                <span>Težina (kg):</span>
                                <span>{item.tezina}</span>
                              </div>
                              <div className="flex justify-between mb-1">
                                <span>Visina (cm):</span>
                                <span>{item.visina}</span>
                              </div>
                              <div className="flex justify-between mb-1">
                                <span>BMI (kg/m&sup2;):</span>
                                <span>{item.bmi}</span>
                              </div>
                              {gender === "female" && (
                                <div className="flex justify-between mb-1">
                                  <span>Kuk (cm):</span>
                                  <span>{item.kuk}</span>
                                </div>
                              )}
                            </div>
                          </details>

                          <details className="mb-2">
                            <summary className="font-semibold cursor-pointer">
                              Ostalo
                            </summary>
                            <div className="pl-4">
                              <div className="flex justify-between mb-1">
                                <span>Procenat telesne masti (%):</span>
                                <span>{item.procenatTelesneMase}</span>
                              </div>
                              <div className="flex justify-between mb-1">
                                <span>Telesna masa (kg):</span>
                                <span>{item.telesnaMasa}</span>
                              </div>
                              <div className="flex justify-between mb-1">
                                <span>Čista telesna masa (kg):</span>
                                <span>{item.cistaTelesnaMast}</span>
                              </div>
                              <div className="flex justify-between mb-1">
                                <span>Idealne telesne masti (%):</span>
                                <span>{item.idealneTelesneMasti}</span>
                              </div>
                              <div className="flex justify-center mb-1">
                                <span>
                                  Potrebno povećanje | smanjenje telesne mase
                                  (kg):
                                </span>
                              </div>
                              <div className="flex justify-center mb-1">
                                <span>{item.povecanje}</span>
                                <span className="mx-2">|</span>
                                <span>{item.smanjenje}</span>
                              </div>
                              <div className="flex justify-between mb-1">
                                <span>Telesna masa BMI (%):</span>
                                <span>{item.telesnaMasaBmi}</span>
                              </div>
                              <div className="flex justify-between mb-1">
                                <span>Kategorija telesne mase:</span>
                                <span>{item.kategorija}</span>
                              </div>
                              <div className="flex justify-between mb-1">
                                <span>Raspoloženje:</span>
                                <span>{item?.emojiIcon}</span>
                              </div>
                              <div className="flex justify-between mb-1">
                                <span>Komentar:</span>
                                {/* <span title={item?.komentar}> */}
                                <span title={item?.komentar}>
                                  {/* {item?.komentar?.length > 10
                                  ? `${item?.komentar.slice(0, 10)}...`
                                  : item?.komentar} */}{" "}
                                  {item?.komentar}
                                </span>
                              </div>
                            </div>
                          </details>

                          <div className="flex justify-end">
                            <button
                              onClick={() => setIdDnevnikaZaBris(item._id)}
                              className="text-red-600"
                            >
                              <TrashIcon className="h-5 w-5" />
                            </button>
                          </div>
                        </div>
                      ))}

                  {mojDnevnikData == null && (
                    <p className="text-lg font-bold text-center py-4">
                      Nemate ni jednu evidenciju u dnevniku
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />

        <div className="w-full">
          {primaryYAxis !== "" && chartData !== "" ? (
            <>
              <h2 className="text-lg font-bold mb-2 text-center">
                Telesne masti
              </h2>
              <AreaChart
                data={chartData}
                index="date"
                categories={[
                  "Telesna Masti (kg)",
                  "Procenat Telesne Masti (%)",
                  "Čista Telesna Masa (kg)",
                ]}
                colors={["cyan", "magenta", "blue"]}
                yAxis={primaryYAxis}
                yAxisSecondary={secondaryYAxis}
                className="h-80"
                tooltip={{
                  enabled: true,
                  style: {
                    background: "rgba(255, 255, 255, 0.9)",
                    borderRadius: "0.5rem",
                  },
                }}
              />
            </>
          ) : (
            <h2 className="text-lg font-bold mb-2 text-center">
              Nema podataka za graf
            </h2>
          )}

          <br />
          <br />

          {/* {DonutChartData !== "" ? (
            <>
              <h2 className="text-lg font-bold mb-2 text-center">
                Kategorije (Osnovna mast, Fit, Sportista, Gojaznoist, Prosečna)
              </h2>
              <div className="flex justify-center">
                <div className="w-full max-w-xs md:max-w-sm lg:max-w-md">
                  <DonutChart
                    data={DonutChartData}
                    category="value"
                    index="name"
                    colors={["blue", "cyan", "green", "yellow", "red"]}
                    className="h-48 md:h-60 lg:h-80 w-full" // Make height responsive
                    variant="pie"
                    tooltip={{
                      enabled: true,
                      style: {
                        background: "rgba(255, 255, 255, 0.9)",
                        borderRadius: "0.5rem",
                      },
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            <h2 className="text-lg font-bold mb-2 text-center">
              Nema podataka za graf
            </h2>
          )} */}
        </div>

        <br />
        <br />

        {/* Emoji chart */}
        {emojiData && emojiData.length > 0 && (
          <EmojisChart emojiData={emojiData} />
        )}

        <br />
        <br />
      </div>

      {/* Popup forme */}
      {showFormPopup && age !== "" && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
          <div
            ref={popupRef}
            className="relative p-2 border w-full max-w-2xl mx-4 shadow-lg rounded bg-white overflow-y-auto max-h-[90vh] transform -translate-y-6"
          >
            {/* Zatvori dugme */}
            <button
              onClick={() => setShowFormPopup(false)}
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 focus:outline-none"
              aria-label="Close"
            >
              X
            </button>

            <h2 className="text-2xl font-bold text-center">
              Kalkulator Telesne Masti (U.S. Navy metoda)
            </h2>

            <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="w-full">
                <label className="block mb-1">Godine</label>
                <input
                  type="number"
                  value={age}
                  onChange={(e) => setAge(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded"
                  readOnly
                />
              </div>

              <div className="w-full">
                <label className="block mb-1">Datum</label>
                <input
                  type="date"
                  value={datum}
                  onChange={(e) => setDatum(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                />
              </div>

              <div className="w-full">
                <label className="block mb-1">Težina (kg)</label>
                <input
                  type="number"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                />
              </div>

              <div className="w-full">
                <label className="block mb-1">Visina (cm)</label>
                <input
                  type="number"
                  value={height}
                  onChange={(e) => setHeight(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                />
              </div>

              <div className="w-full">
                <label className="block mb-1">Obim Struka (cm)</label>
                <input
                  type="number"
                  value={waist}
                  onChange={(e) => setWaist(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                />
              </div>

              {gender === "female" && (
                <div className="w-full">
                  <label className="block mb-1">Obim Kukova (cm)</label>
                  <input
                    type="number"
                    value={hip}
                    onChange={(e) => setHip(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded"
                    required
                  />
                </div>
              )}

              <div className="w-full">
                <label className="block mb-1">Obim Vrata (cm)</label>
                <input
                  type="number"
                  value={neck}
                  onChange={(e) => setNeck(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded"
                  required
                />
              </div>
            </form>

            <div className="col-span-2 mt-2">
              <button
                type="button"
                onClick={calculateBodyFat}
                className="w-full py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
              >
                Izračunaj Telesne Masti
              </button>
            </div>

            {bodyFat && (
              <>
                <div className="mt-2 col-span-2">
                  <table className="min-w-full border border-gray-300">
                    <thead>
                      <tr className="bg-gray-100">
                        <th className="border px-4 py-2">Metrika</th>
                        <th className="border px-4 py-2">Vrednost</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border px-4 py-2">
                          Procenat telesne masti
                        </td>
                        <td className="border px-4 py-2">{bodyFat}%</td>
                      </tr>
                      <tr>
                        <td className="border px-4 py-2">Telesne masti</td>
                        <td className="border px-4 py-2">{bodyFatMass} kg</td>
                      </tr>
                      <tr>
                        <td className="border px-4 py-2">Čista telesna masa</td>
                        <td className="border px-4 py-2">{leanBodyMass} kg</td>
                      </tr>
                      <tr>
                        <td className="border px-4 py-2">
                          Idealne telesne masti za uzrast
                        </td>
                        <td className="border px-4 py-2">{idealBodyFat}%</td>
                      </tr>
                      {bodyFatToGain > 0 && (
                        <tr>
                          <td className="border px-4 py-2">
                            Telesne masti koje treba da se dobiju
                          </td>
                          <td className="border px-4 py-2">
                            {bodyFatToGain} kg
                          </td>
                        </tr>
                      )}
                      {fatLossAmount > 0 && (
                        <tr>
                          <td className="border px-4 py-2">
                            Telesne masti za gubitak
                          </td>
                          <td className="border px-4 py-2">
                            {fatLossAmount} kg
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td className="border px-4 py-2">
                          Telesne masti (BMI metoda)
                        </td>
                        <td className="border px-4 py-2">{bmiBodyFat}%</td>
                      </tr>
                      <tr>
                        <td className="border px-4 py-2">
                          Kategorija telesne masti
                        </td>
                        <td className="border px-4 py-2">{bodyFatCategory}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div className="flex items-center justify-between w-full mt-1">
                  <button
                    type="button"
                    // onClick={handleSacuvajClick}
                    onClick={() => setIsModalPitalica(true)}
                    className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600"
                  >
                    Sačuvaj
                  </button>

                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)}
                      className="mr-2"
                    />
                    <label className="text-gray-700">Sacuvaj u profil</label>
                  </div>
                </div>
              </>
            )}

            {/* Kontrole za zatvaranje popup-a */}
            {/* <div className="flex justify-between mt-4 col-span-2">
                <button
                  type="button"
                  onClick={() => setShowFormPopup(false)}
                  className="w-1/2 mr-1 px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                >
                  Ugasi
                </button>
              </div> */}

            {/* Upozorenje Popup */}
            {showWarningPopup && (
              <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
                <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
                  <div className="mt-3 text-center">
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                      <svg
                        className="h-6 w-6 text-yellow-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                      Upozorenje
                    </h3>
                    <div className="mt-2 px-7 py-3">
                      <p className="text-sm text-gray-500">{popupMessage}</p>
                    </div>
                    <div className="items-center px-4 py-3">
                      <button
                        onClick={closeModalPosta}
                        className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                      >
                        Zatvori
                      </button>
                      <button
                        onClick={handleIntegrisi}
                        className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                      >
                        Sačuvaj u profil
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* work here */}
      {isModalPitalica && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
          <div className="relative p-4 border w-96 shadow-lg rounded bg-white">
            <div className="mt-3 text-center">
              <h3 className="text-lg font-medium text-gray-900 mb-4">
                Kako se osećate danas?
              </h3>
              <div className="mt-4 flex flex-wrap justify-center gap-4">
                <button
                  onClick={() => handleClick("😡")}
                  className={`px-6 py-3 text-base font-medium rounded-md w-32 shadow-sm border-2 ${
                    selectedEmoji === "😡"
                      ? "bg-green-500 text-black border-green-500"
                      : "bg-white text-red-500 border-green-500"
                  } hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-green-300 flex items-center justify-start gap-2`}
                >
                  <span>Anger</span> <span className="text-2xl">😡</span>
                </button>
                <button
                  onClick={() => handleClick("😞")}
                  className={`px-6 py-3 text-base font-medium rounded-md w-32 shadow-sm border-2 ${
                    selectedEmoji === "😞"
                      ? "bg-green-500 text-black border-green-500"
                      : "bg-white text-purple-500 border-green-500"
                  } hover:bg-purple-100 focus:outline-none focus:ring-2 focus:ring-green-300 flex items-center justify-start gap-2`}
                >
                  <span>Sad</span> <span className="text-2xl">😞</span>
                </button>
                <button
                  onClick={() => handleClick("😐")}
                  className={`px-6 py-3 text-base font-medium rounded-md w-32 shadow-sm border-2 ${
                    selectedEmoji === "😐"
                      ? "bg-green-500 text-black border-green-500"
                      : "bg-white text-blue-500 border-green-500"
                  } hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-green-300 flex items-center justify-start gap-2`}
                >
                  <span>Neutral</span> <span className="text-2xl">😐</span>
                </button>
                <button
                  onClick={() => handleClick("😊")}
                  className={`px-6 py-3 text-base font-medium rounded-md w-32 shadow-sm border-2 ${
                    selectedEmoji === "😊"
                      ? "bg-green-500 text-black border-green-500"
                      : "bg-white text-yellow-500 border-green-500"
                  } hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-green-300 flex items-center justify-start gap-2`}
                >
                  <span>Happy</span> <span className="text-2xl">😊</span>
                </button>
                <button
                  onClick={() => handleClick("😁")}
                  className={`px-6 py-3 text-base font-medium rounded-md w-32 shadow-sm border-2 ${
                    selectedEmoji === "😁"
                      ? "bg-green-500 text-black border-green-500"
                      : "bg-white text-green-500 border-green-500"
                  } hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-300 flex items-center justify-start gap-2`}
                >
                  <span>Excited</span> <span className="text-2xl">😁</span>
                </button>
              </div>
              {/* <div className="mt-4 flex flex-wrap justify-center gap-4">
                <button
                  onClick={() => setEmojiData("😡")}
                  className="px-6 py-3 bg-white text-red-500 text-base font-medium rounded-md w-32 shadow-sm border-2 border-green-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-green-300 flex items-center justify-start gap-2"
                >
                  <span>Anger</span> <span className="text-2xl">😡</span>
                </button>
                <button
                  onClick={() => setEmojiData("😞")}
                  className="px-6 py-3 bg-white text-purple-500 text-base font-medium rounded-md w-32 shadow-sm border-2 border-green-500 hover:bg-purple-100 focus:outline-none focus:ring-2 focus:ring-green-300 flex items-center justify-start gap-2"
                >
                  <span>Sad</span> <span className="text-2xl">😞</span>
                </button>
                <button
                  onClick={() => setEmojiData("😐")}
                  className="px-6 py-3 bg-white text-blue-500 text-base font-medium rounded-md w-32 shadow-sm border-2 border-green-500 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-green-300 flex items-center justify-start gap-2"
                >
                  <span>Neutral</span> <span className="text-2xl">😐</span>
                </button>
                <button
                  onClick={() => setEmojiData("😊")}
                  className="px-6 py-3 bg-white text-yellow-500 text-base font-medium rounded-md w-32 shadow-sm border-2 border-green-500 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-green-300 flex items-center justify-start gap-2"
                >
                  <span>Happy</span> <span className="text-2xl">😊</span>
                </button>
                <button
                  onClick={() => setEmojiData("😁")}
                  className="px-6 py-3 bg-white text-green-500 text-base font-medium rounded-md w-32 shadow-sm border-2 border-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-300 flex items-center justify-start gap-2"
                >
                  <span>Excited</span> <span className="text-2xl">😁</span>
                </button>
              </div> */}

              <div className="mt-2 px-7 py-3">
                <p className="text-sm text-gray-500">
                  Da li imate nešto da podelite?
                </p>
                <p className="text-sm text-gray-500">
                  Kako vam se čini današnja ishrana?
                </p>
              </div>

              <div className="mt-4">
                <textarea
                  className="w-full p-2 border border-gray-300 rounded"
                  value={komentar}
                  onChange={(e) => setKomentar(e.target.value)}
                  placeholder="Upišite ovde..."
                  rows="4"
                />
              </div>

              {/* work here */}
              <div className="flex justify-between gap-2 mt-4">
                <button
                  onClick={handleSacuvajClick}
                  className="px-3 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                >
                  Sačuvaj
                </button>
                <button
                  onClick={() => setIsModalPitalica(false)}
                  className="px-3 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                >
                  Ugasi
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center">
          <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
            <div className="mt-3 text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                <svg
                  className="h-6 w-6 text-yellow-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                Upoznorenje
              </h3>
              <div className="mt-2 px-7 py-3">
                <p className="text-sm text-gray-500">
                  Da li ste sigurni da želite izbrisati odbaran red evidencije
                </p>
              </div>
              <div className="items-center px-4 py-3">
                <button
                  onClick={handleDelDnevnikKorisnik}
                  className="px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                >
                  Da
                </button>
                <button
                  onClick={closeModal}
                  className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                >
                  Ne
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

export default MojDnevnik;
